export default __webpack_public_path__ + "static/media/subscription.dd42bd3b.svg";